import { dataLayerTrackEvent } from '@utils/tracking';
import { ICollectionTag } from '@monofront/types';
import { useTranslations } from 'next-intl';
import Arrow from '@monofront/design-system/visuals/Icons/Old/Arrow';
import Link from 'next/link';
import React from 'react';

interface IGoBackLinkProps {
  currentPathTitle: string;
  breadcrumb?: ICollectionTag[];
  UNSAFE_className?: string;
}

export const GoBackLink: React.FC<IGoBackLinkProps> = ({
  currentPathTitle,
  breadcrumb = [],
  UNSAFE_className = '',
}) => {
  const tGlobal = useTranslations('Global');

  dataLayerTrackEvent('topCategory', {
    topCategory: breadcrumb[1]?.title || currentPathTitle,
  });

  const parentLink =
    breadcrumb.length >= 2
      ? `/collections/${breadcrumb[breadcrumb.length - 1].handle}`
      : '/';
  const parentLinkTitle =
    breadcrumb.length >= 2
      ? breadcrumb[breadcrumb.length - 1].title
      : tGlobal('home');

  return (
    <Link
      href={parentLink}
      title={parentLinkTitle}
      className={`${UNSAFE_className} tw-lf-button tw-lf-button-ghost tw-lf-button-md tw-lf-body-regular-md tw-inline-flex tw-p-0`}
      data-testid="LayoutCollection-Button-1"
    >
      <Arrow headDirection="left" color="var(--black)" width={11} height={18} />
      {parentLinkTitle}
    </Link>
  );
};
